module.exports = __webpack_public_path__ + "bbdfaa2c84102d10d84c988758af1598.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/workshop-hat.png
 ** module id = 481
 ** module chunks = 0
 **/